import React, {useState, useEffect} from 'react';
import {Modal} from "react-bootstrap";
import * as Styled from './ResultDetailsStyles';
import closeIcon from "../../../images/close-icon.svg";
import {ResultBody} from "./ResultItem";
import Api from "../../api/Api";
import Feedback from "../../components/Feedback/Feedback";
import {sanitizeUrl} from '../../helpers/sanitizeURL';
interface ResultDetailsProps{
  item: any;
  isOpen: boolean;
  onClose: Function;
  queryTs?: string | undefined;
  onBookmark?: Function;
  isMarked?: boolean;
}

const goToTexts:any = {
  gmail: 'Go to message',
  slack: 'Go to message',
  teams: 'Go to message',
  outlook: 'Go to message',
  jira: 'Go to ticket',
  gdrive: 'Go to file',
  dropbox: 'Go to file',
}

const fetchPermalink = (item:any) => {
  const req:any = {
    platform: item.pl,
  };
  if (item.pl === 'gmail') {
    req.msg_id= item.msg_id;
    req.email = item.gmail_account;
  }
  if (item.pl === 'slack') {
    req.team_id = item.team;
    req.conversation_id = item.conversation_id;
    req.message_ts = item.timestamp;
  }

  return Api.getPermalink(req);
}

const ResultDetails = ({ item, onClose }: ResultDetailsProps) => {
  const [permalink, setPermalink] = useState('');
  const [activeItem, setActiveItem] = useState(item);
  useEffect(() => {
    if (!item) {
      setActiveItem(item);
      return;
    }
    if (!item.permalink) {
      fetchPermalink(item).then(res => {
        setPermalink(res?.data?.link);
      });
    } else {
      setPermalink(sanitizeUrl(item.permalink));
    }

    setActiveItem(item);
  }, [item]);

  const onGoToMessage = (e:any) => {
    if (!permalink) {
      e.preventDefault();
    }
    return true;
  }

  if (!activeItem) {
    return null;
  }

  return (
    <Modal
      show={!!activeItem}
      onHide={onClose}
      size="xl"
      fullscreen="xl-down"
      centered
      contentClassName='results-modal-content'
      dialogClassName='results-modal-dialog'
    >
      <Styled.StyledModalBody>
        <ResultBody item={activeItem} isPreview />
      </Styled.StyledModalBody>
      {activeItem.pl !== 'jira' && (
        <Styled.StyledModalFooter>
          <Styled.StyledAnchor
            className={`ModalFooterBtn Msg ${!permalink ? 'Disabled' : ''}`}
            href={permalink}
            target={`trova-${activeItem.pl}`}
            onClick={onGoToMessage}
          >
            {goToTexts[activeItem.pl] || `Go to ${activeItem.filter}`}
          </Styled.StyledAnchor>
          <Feedback item={activeItem} contained />
          {/*{!!onBookmark && <ResultBookmark
            isMarked={isMarked}
            onClick={() => onBookmark(activeItem, isMarked)}
          />}*/}
        </Styled.StyledModalFooter>
      )}
      <Styled.StyledBtn
        onClick={onClose}
        className='ResultsModalClose'
        variant='link'
      >
        <img src={closeIcon} alt='' />
      </Styled.StyledBtn>
    </Modal>
  )
}

export default ResultDetails;